import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';
import SearchResults from './pages/SearchResults'; 
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import UpgradePro from './pages/UpgradePro';
import AddBusiness from './sections/profile/AddBusiness';
import VendorPage from './sections/@dashboard/products/VendorPage';
import UploadImages from './sections/@dashboard/album/UploadImages';
import NEwProjects from './sections/@dashboard/projects/NEwProjects';
import ManageProject from './sections/@dashboard/projects/ManageProject';
import ManagePage from './sections/@dashboard/products/ManagePage';
import EditPage from './sections/@dashboard/products/EditPage';
import Marketplace from './pages/Marketplace';
import ViewBlogPost from './sections/@dashboard/blog/ViewBlogPost';
import Inbox from './pages/Inbox';
import Explore from './pages/Explore';
import Payment from './pages/Payment';
import Onboarding from './pages/Onboarding';
import UserProfile from './sections/profile/UserProfile';
import CreateSite from './sections/@dashboard/sites/CreateSite';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
    //  element: <SimpleLayout />,
       element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        //  { path: 'app', element: <Onboarding /> },
       { path: 'app', element: <DashboardAppPage /> },
        { path: 'tracker', element: <UserPage /> },
        { path: 'products', element: <ProductsPage /> },
        { path: 'blog', element: <BlogPage /> },
        { path: 'search', element: <SearchResults /> },
        { path: 'upgradetopro', element: <UpgradePro /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'addBusiness', element: <AddBusiness /> },
        { path: 'vendorPage/:id', element: <VendorPage /> },
        { path: 'uploadImages/:id', element: <UploadImages /> },
        { path: 'newProject/', element: <NEwProjects /> },
        { path: 'viewProject/', element: <ManageProject /> },
        { path: 'managePage/', element: <ManagePage /> },
        { path: 'editPage/', element: <EditPage /> },
        { path: 'inbox/', element: <Inbox /> },
        { path: 'marketplace/', element: <Marketplace /> },
        { path: 'viewBlogPost/', element: <ViewBlogPost /> }, 
        { path: 'explore/', element: <Explore /> }, 
        { path: 'payment/', element: <Payment /> }, 
        { path: 'userProfile/', element: <UserProfile /> }, 
        { path: 'createSite/', element: <CreateSite /> }, 
       
     ],
   }, 
    // { path: '/welcome', element: <Onboarding /> }, 
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'register',
      element: <RegisterPage />,
    },
   
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
